/*------footer-js-----------*/
document.addEventListener('DOMContentLoaded', function () {
  applyAOSAttributes();
  AOS.init();
});

const footerSection = document.querySelector('.footer');

const footerObserverCallback = (entries, footerObserver) => {
  entries.forEach(entry => {
    if (entry.isIntersecting && entry.intersectionRatio >= 0.01) {
      AOS.refresh();   
      footerObserver.disconnect();  
    }
  });
};

const footerObserverOptions = {
  root: null,  
  threshold: 0.01,   
};

const footerObserver = new IntersectionObserver(footerObserverCallback, footerObserverOptions);
footerObserver.observe(footerSection);

function applyAOSAttributes() {
  for (let i = 1; i <= 4; i++) {
    const menu = document.querySelector(`.footer_menu_${i}`);

    if (menu) {
      menu.setAttribute('data-aos-once', 'true');  
      menu.setAttribute('data-aos', 'fade-up');   
      menu.setAttribute('data-aos-duration', '1000');  

      
      const delay = i === 1 ? 300 : 600;  
      menu.setAttribute('data-aos-delay', delay.toString());
    }
  }
}

/*----------footer-js-end-------*/

document.addEventListener("DOMContentLoaded", function() {
    AOS.init();
    
    const checkPage = document.querySelector('.page_index')

    if(checkPage) {

        const stickySection = document.querySelector('.sticky-section');
        const customColl = document.querySelector('.custom-collection-section');
        const stickyCommonSections = document.querySelectorAll('.sticky-common-section');
        const firstStickyCommonSection = stickyCommonSections[0];
        const secondStickyCommonSection = stickyCommonSections[1];
        const shopifySection = document.querySelector('.shopify-section.section.custom_richtext');
        const downArrow = document.querySelector('.down-arrow');

        if(stickyCommonSections) {
            firstStickyCommonSection.classList.add('first-node-section');
            secondStickyCommonSection.classList.add('second-node-section');
        }

        const stickySectionObserverOptions = {
            root: null,
            rootMargin: '0px',
            threshold: [0],
        };

        const shopifySectionObserverOptions = {
            root: null,
            rootMargin: '0px',
            threshold: [0.01],
        };

        const stickySectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if(entry.target === stickySection && entry.isIntersecting) {
                    stickySection.classList.add('sticky-added');
                    firstStickyCommonSection.classList.add('sticky-added');
                    secondStickyCommonSection.classList.add('sticky-added');
                    customColl.classList.add('sticky-added');


                }
            });
        }, stickySectionObserverOptions);

        const shopifySectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if(entry.target === shopifySection && entry.isIntersecting) {
                    stickySection.classList.remove('sticky-added');
                    firstStickyCommonSection.classList.remove('sticky-added');
                    secondStickyCommonSection.classList.remove('sticky-added');
                    secondStickyCommonSection.style.background = "#e3aa61";
                    customColl.classList.remove('sticky-added');

                } else {
                    stickySection.classList.add('sticky-added');
                    firstStickyCommonSection.classList.add('sticky-added');
                    secondStickyCommonSection.classList.add('sticky-added');
                    secondStickyCommonSection.style.background = "transparent";
                    customColl.classList.add('sticky-added');

                }
            });
        }, shopifySectionObserverOptions);

        stickySectionObserver.observe(stickySection);
        shopifySectionObserver.observe(shopifySection);

        if(downArrow) {
            downArrow.addEventListener('click', () => {
                firstStickyCommonSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest',
                });
            });
        }

        const newStickySection = document.querySelector('.sticky-section');
        const newShopifySection = document.querySelector('.shopify-section.section.custom_richtext');

        const newStickySectionObserverOptions = {
            root: null,
            rootMargin: '0px',
            threshold: [0.80], // Trigger when stickySection is more than 10% visible
        };

        const newShopifySectionObserverOptions = {
            root: null,
            rootMargin: '0px',
            threshold: [0.10], // Trigger when shopifySection is more than 80% visible
        };

        const newStickySectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if(entry.target === newStickySection) {
                    if(entry.isIntersecting && entry.intersectionRatio > 0.10) {
                        document.body.classList.add('new-gradient');
                        document.body.classList.remove('gradient');
                    } else {
                        document.body.classList.remove('new-gradient');
                        document.body.classList.add('gradient');
                    }
                }
            });
        }, newStickySectionObserverOptions);

        const newShopifySectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if(entry.target === newShopifySection) {
                    if(entry.isIntersecting && entry.intersectionRatio > 0.80) {
                        document.body.classList.remove('new-gradient');
                        document.body.classList.add('gradient');
                    }
                }
            });
        }, newShopifySectionObserverOptions);

        newStickySectionObserver.observe(newStickySection);
        newShopifySectionObserver.observe(newShopifySection);


        setTimeout(() => {
            document.querySelector('.banner__buttons')?.classList.add('show');
        }, 1500);

        const yogableObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if(!entry.isIntersecting) return;

                const headingLines = entry.target.querySelectorAll('.heading-line');
                headingLines.forEach(line => {
                    setTimeout(() => {
                        line.classList.add('animate-progress');
                    }, 1500);
                });
                setTimeout(() => {
                    entry.target
                        .querySelector('.banner_block_image')
                        ?.classList.add('remove-blur');
                }, 800);

                setTimeout(() => {
                    entry.target
                        .querySelector('.banner__buttons')
                        ?.classList.add('remove-blur');
                }, 100);

                observer.unobserve(entry.target);
            });
        }, {
            threshold: 0.3
        });
        const yogableSection = document.querySelector('.yogable_2');
        if(yogableSection) {
            yogableObserver.observe(yogableSection);
        }

        /*---featured-collection--js----*/

        const section = document.querySelector(".Ps_featured_collection");
        const title = section?.querySelector(".ps_collection_title");

        if(!section || !title) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if(entry.isIntersecting) {
                        setTimeout(() => {
                            title.classList.add("featured_bar");
                        }, 1500);
                        observer.unobserve(section);
                    }
                });
            }, {
                threshold: 0.3,
            }
        );

        observer.observe(section);

        /*----------video-popup-section--js----------*/

        const videoSection = document.querySelector('.video-popup-section');

        if(videoSection) {
            const videoSectionObserver = new IntersectionObserver(
                (entries, observer) => {
                    entries.forEach((entry) => {
                        if(entry.isIntersecting) {
                            setTimeout(() => {
                                entry.target.classList.add("videoElement");

                                const headingImg = entry.target.querySelector('.heading-wrapper img');
                                headingImg?.classList.add('remove-blur');
                            }, 1000);

                            setTimeout(() => {
                                const videopoup = entry.target.querySelector('.popup-open');
                                videopoup?.classList.add('remove-blur');
                            }, 2000);

                            setTimeout(() => {
                                const videopoup = entry.target.querySelector('.another-brand-logo');
                                videopoup?.classList.add('remove-blur');
                            }, 2300);

                            observer.unobserve(entry.target);
                        }
                    });
                }, {
                    threshold: 0.3,
                }
            );

            videoSectionObserver.observe(videoSection);
        }


        /*------------tree-section-js------*/


        const treeAnimationSection = document.querySelector('.tree-animation-section');

        if(treeAnimationSection) {
            const treeAnimationSectionObserver = new IntersectionObserver(
                (entries, observer) => {
                    entries.forEach((entry) => {
                        if(entry.isIntersecting) {

                            setTimeout(() => {
                                entry.target.classList.add("treeElement");

                                const headingOne = entry.target.querySelector('.head_one');
                                headingOne?.classList.add('remove-blur');
                            }, 1000);

                            setTimeout(() => {
                                const hrLine = entry.target.querySelector('.headings-box hr');
                                hrLine?.classList.add('remove-blur');

                                const headingTwo = entry.target.querySelector('.head_two');
                                headingTwo?.classList.add('remove-blur');

                                const treeSubHeading = entry.target.querySelector('.sub-heading');
                                treeSubHeading?.classList.add('remove-blur');

                            }, 1500);

                            setTimeout(() => {
                                const dowmArrowT = entry.target.querySelector('.down-arrow');
                                dowmArrowT?.classList.add('remove-blur');
                            }, 2200);

                            observer.unobserve(entry.target);
                        }
                    });
                }, {
                    threshold: 0.3,
                }
            );

            treeAnimationSectionObserver.observe(treeAnimationSection);
        }

        /*-------tree-block-1---------*/

        const tree_block_first = document.querySelector('.first-node-section');

        const tree_block_first_observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if(entry.isIntersecting) {
                        entry.target.classList.add('tree_block_1');
                        setTimeout(() => {
                            const heagins_bar = entry.target.querySelector('.heagins-box');
                            heagins_bar?.classList.add('active_bar_h');
                        }, 1500);
                        setTimeout(() => {
                            const treeBlocks = entry.target.querySelectorAll('.block-text');
                            treeBlocks.forEach((block) => {
                                block.classList.add('tree_bar');
                            });
                        }, 2000);

                    }
                });
            }, {
                threshold: 0.2
            }
        );

        tree_block_first_observer.observe(tree_block_first);


        /* ------- tree-block-2 -------- */

        const tree_block_second = document.querySelector('.second-node-section');

        const tree_block_second_observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if(entry.isIntersecting) {
                        entry.target.classList.add('tree_block_2');
                        setTimeout(() => {
                            const heagins_bar = entry.target.querySelector('.heagins-box');
                            heagins_bar?.classList.add('active_bar_h');
                        }, 2000);

                        setTimeout(() => {
                            const treeBlocks = entry.target.querySelectorAll('.block-text');
                            treeBlocks.forEach((block) => {
                                block.classList.add('tree_bar');
                            });
                        }, 3000);

                        tree_block_second_observer.unobserve(entry.target);
                    }
                });
            }, {
                threshold: 0.2
            }
        );

        tree_block_second_observer.observe(tree_block_second);

        /*------------leaf-move--js-------------*/

        const firstTreeNodeSection = document.querySelector('.first-node-section');
        const stickyNodeSection = document.querySelector('.sticky-section');
        const leftWrapperElement = document.querySelector('.tree-animation-section .left-wrapper');
        const treeLeafElements = document.querySelectorAll('.leaf');

        let isStickyActive = false;
        let stopScrollAnimation = false;

        let lastScrollY = window.scrollY;
        let leftWrapperX = 0;
        let leafX = 0;

        /* ---------- Sticky Section (100% reveal = START) ---------- */

        const stickyObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    isStickyActive = entry.intersectionRatio >= 0.1;
                });
            }, {
                threshold: [0.1]
            }
        );

        /* ---------- First Node Section (90% reveal = STOP) ---------- */
        const firstNodeObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    stopScrollAnimation = entry.intersectionRatio >= 0.9;
                });
            }, {
                threshold: [0, 0.9]
            }
        );

        stickyObserver.observe(stickyNodeSection);
        firstNodeObserver.observe(firstTreeNodeSection);


        const innerWidth = window.innerWidth;  
        const isMobile = innerWidth < 749;

        /* ---------- SCROLL HANDLER ---------- */
        window.addEventListener('scroll', () => {
            if(!isStickyActive || stopScrollAnimation) {
                lastScrollY = window.scrollY;
                return;
            }

            const currentScrollY = window.scrollY;
            const scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';

            if(scrollDirection === 'down') {
                if(isMobile) {
                    leftWrapperX += 0.2;
                    console.log("0.2 Applyed");
                leafX += 0.5;

                } else {
                    leftWrapperX += 0.3;
                    console.log("0.3 Applyed");
                leafX += 0.7;

                }
                // leafX += 0.7;
            } else {
                 if(isMobile) {
                leftWrapperX -= 0.2;
                leafX -= 0.5;

                 } else {
                leftWrapperX -= 0.3;
                leafX -= 0.7;


                 }

                // leafX -= 0.7;
            }

            // Prevent negative values
            leftWrapperX = Math.max(0, leftWrapperX);
            leafX = Math.max(0, leafX);

            leftWrapperElement.style.transform = `translateX(${leftWrapperX}px)`;

            treeLeafElements.forEach(leaf => {
                leaf.style.transform = `translateX(${leafX}px)`;
            });

            lastScrollY = currentScrollY;
        });



        /*----------insta-image-scroll-js----------*/

    window.addEventListener('load', () => {
        const innerWidth = window.innerWidth;  
        console.log("Inner Width: ", innerWidth);

        const mobileSize = 130;
        const TabletSize = 190;
    const desktopSize = 330;

        const isMobile = innerWidth < 749;
        const isTablet = innerWidth < 990;

        let appliedSize;

        const row1 = document.querySelector('.block_image_row_1 .image_block_row');
        const row2 = document.querySelector('.block_image_row_2 .image_block_row');

        if (isMobile) {
            appliedSize = mobileSize;
        } else if (isTablet) {
            appliedSize = TabletSize;
        } else {
            appliedSize = desktopSize;
        }

        const row1Images = row1.querySelectorAll('img');
        row1Images.forEach(img => {
            img.style.width = `${appliedSize}px`;
            img.style.height = `${appliedSize}px`; 
        });

        const row2Images = row2.querySelectorAll('img');
        row2Images.forEach(img => {
            img.style.width = `${appliedSize}px`;
            img.style.height = `${appliedSize}px`;  
        });

        const row1Element = document.querySelector('.block_image_row_1');
        const row2Element = document.querySelector('.block_image_row_2');
        
        let isActive = false;
        let lastScrollY = window.scrollY;

        const STEP = 1;
        const MAX_TRANSLATE = 700;

        const getTranslateX = (el) => {
            const transform = getComputedStyle(el).transform;
            if (transform === 'none') return 0;
            return new DOMMatrix(transform).m41;
        };

        const baseRow1 = getTranslateX(row1Element);
        const baseRow2 = getTranslateX(row2Element);

        let offsetX = 0;

        const observerElement = document.querySelector('.observerelement');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                isActive = entry.isIntersecting;
                lastScrollY = window.scrollY;
            });
        }, {
            threshold: 0.4
        });

        observer.observe(observerElement);

        window.addEventListener('scroll', () => {
            if (!isActive) return;

            const currentScrollY = window.scrollY;
            const deltaY = currentScrollY - lastScrollY;

            if (deltaY === 0) return;

            offsetX += Math.sign(deltaY) * STEP;

            offsetX = Math.max(
                -MAX_TRANSLATE,
                Math.min(offsetX, MAX_TRANSLATE)
            );

            row1Element.style.transform = `translateX(${baseRow1 - offsetX}px)`;
            row2Element.style.transform = `translateX(${baseRow2 + offsetX}px)`;

            lastScrollY = currentScrollY;
        });
    });



    }

    


});